"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var mixins = require.context('./mixins', true, /.*.js$/);

// console.log('mixins.keys()', mixins.keys())
var _default2 = exports.default = {
  name: 'wlTable',
  /* 混入 */
  mixins: mixins.keys().map(function (key) {
    return mixins(key).default;
  }).filter(function (file) {
    return file;
  }),
  props: {
    /* 静态表格 */
    staticTable: {
      type: Boolean,
      default: true
    },
    /* 外部传入 */
    datas: {
      type: [Object, Array],
      default: function _default() {
        return [];
      }
    },
    /* 数据源 */
    dataSource: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 表格操作按钮 */
    operations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /* 设置表格列 */
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /* 表格行操作按钮 */
    rowOperations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /* 设置表格 ref 参数 */
    refTable: {
      type: String,
      default: ''
    },
    /* 设置分页器 ref 参数 */
    refPagination: {
      type: String,
      default: ''
    },
    /* 参数设置 ↓  */
    /* 设置表格，对象参数参考 https://element.eleme.cn/2.13/#/zh-CN/component/table#attributes */
    tableOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 表格表单参数 */
    tableFormOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 设置表格，对象参数参考 https://element.eleme.cn/2.13/#/zh-CN/component/table#attributes */
    columnOptions: {
      type: Object,
      default: function _default() {
        return {
          align: 'center'
        };
      }
    },
    /* 序列号列 参数 */
    columnIndexOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 可选框列 参数 */
    columnSelectionOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 行操作 参数 */
    columnOperationsOptions: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /* 设置分页器，对象参数参考 https://element.eleme.cn/2.13/#/zh-CN/component/pagination#attributes */
    paginationOptions: {
      type: [Boolean, Object],
      default: true
    },
    /* 表格是否是表单表格 */
    isForm: {
      type: Boolean,
      default: false
    },
    /* 表格是否是独立的表单表格 */
    isFormSwaraj: {
      type: Boolean,
      default: true
    },
    /* 表格是否需要填充列 */
    needFill: {
      type: Boolean,
      default: false
    }
    /* 表格默认排序 */
    // 'default-sort' : { type: Object, default: () => ({ prop: 'createTime', order: 'descending' }) }
  },
  computed: {
    /** 表格选择模式是否是单选
     * @return { Boolean } 是否是单选状态
     */
    isSingle: function isSingle() {
      return this.table.chooseMode === 'single';
    }
  },
  /* 方法 当前组件可使用的方法 */
  methods: {
    /**
     * @description: 设置选中行
     * @param { * } selections 选中条目
     * @param { String } field 指定条件赛选
     * @return { Boolean } 设置成功状态
     */
    setSelections: function setSelections() {
      var _this = this;
      try {
        var _selections, _selections2;
        var s = arguments[0];
        var field = arguments[1];
        var selections = [];
        if (Array.isArray(s)) (_selections = selections).push.apply(_selections, (0, _toConsumableArray2.default)(s));else selections.push(s);
        selections = (_selections2 = selections) === null || _selections2 === void 0 ? void 0 : _selections2.map(function (selection) {
          var rowKey = '';
          if (typeof selection === 'string') rowKey = selection;else if ((0, _typeof2.default)(selection) === 'object') rowKey = field ? selection[field] : _this.getRowKey(selection);
          return rowKey;
        });
        if (this.isSingle) {
          // const row = this.table?.data
          //   ?.find(r => selections.includes(r[field]))
          // console.log('row', this.table?.data, selections)
        } else {
          var _this$table;
          (_this$table = this.table) === null || _this$table === void 0 || (_this$table = _this$table.data) === null || _this$table === void 0 || _this$table.forEach(function (row) {
            return _this.$refs['el-table'].toggleRowSelection(row, selections.includes(field ? row[field] : _this.getRowKey(row)));
          });
        }
        return true;
      } catch (e) {
        return false;
      }
    },
    /**
     * @description: 获取 分页数据
     * @return { Object } 分页数据
     */
    getPagination: function getPagination() {
      return this.pagination;
    },
    /**
     * @description: 设置分页器
     * @param { Object } pagination - 分页器属性
     * @param { String | Number } pagination.currentPage - 当前页页码
     * @param { String | Number } pagination.pageSize - 每页显示条目
     * @param { String | Number } pagination.total - 条目总数
     * @return { void }
     */
    setPagination: function setPagination(pagination) {
      var p = pagination !== null && pagination !== void 0 ? pagination : this.paginationOptions;
      // 合并分页器的参数设置
      switch (this.$$dataTypeOf(p, true)) {
        case '[object Object]':
          Object.assign(this.pagination, p);
          break;
        case '[object Boolean]':
          this.pagination.show = p;
          break;
      }
    },
    /**
     * @description: 获取 表格选中条目
     * @param { Function } fun 按钮对象
     * @param { Array } fun.a 选中条目
     * @param { Array } fun.b 选中条目中被作为行key的字段
     * @param { Array } fun.c 选中条目中被作为行label的字段
     * @return { Array } 表格选中条目
     */
    getSelection: function getSelection(fun) {
      var a = this.tableSelection;
      var b = a.map(this.getRowKey);
      var c = a.map(this.getRowLabel);
      typeof fun === 'function' && fun(a, b, c);
      return a;
    },
    /** 查找行
     * @description: 查找行，如果行在子级一样找
     * @param { Object | String } row 要查找的行，或者行的KEY值
     * @param { cellback } fun 回调函数
     * @param { cellback } fun.row 被查找的行对象
     * @param { cellback } fun.rowParents 行对象的祖辈
     * @param { cellback } fun.index 被查找的行下标
     * @return { Object } 查找到的行
     */
    findRow: function findRow(row, fun) {
      var _this2 = this;
      var key = arguments[0];
      if ((0, _typeof2.default)(arguments[0]) === 'object') key = this.getRowKey(row);
      if (!key) return false;
      var _this$getTreeProps = this.getTreeProps(),
        children = _this$getTreeProps.children;
      var a = [];
      var c = function c(o) {
        return JSON.stringify(o).includes(key);
      };
      var b;
      var _find = function find(arr) {
        if (c(arr)) {
          return !!arr.find(function (item, i) {
            if (c(item)) {
              a.push(item);
              if (_this2.getRowKey(item) === key) {
                b = item;
                typeof fun === 'function' && fun(b, a, i);
                return true;
              }
              var d = item[children];
              return Array.isArray(d) && c(d) && !!_find(d);
            }
            return false;
          });
        }
        return false;
      };
      _find(this.table.data);
      return b;
    },
    /** 删除行
     * @description: 删除行
     * @param { Object | String } row 要删除掉行数据对象或者该行的 row-key 值
     * @return { void }
     */
    deleteRow: function deleteRow() {
      var _this$$refs$elTable,
        _d$children,
        _this3 = this;
      var key = (0, _typeof2.default)(arguments[0]) === 'object' ? this.getRowKey(arguments[0]) : arguments[0];
      var delRow;
      var _this$$refs$elTable$ = (_this$$refs$elTable = this.$refs['el-table']) === null || _this$$refs$elTable === void 0 || (_this$$refs$elTable = _this$$refs$elTable.store) === null || _this$$refs$elTable === void 0 ? void 0 : _this$$refs$elTable.states,
        treeData = _this$$refs$elTable$.treeData,
        lazyTreeNodeMap = _this$$refs$elTable$.lazyTreeNodeMap;
      var _ref = [treeData[key], lazyTreeNodeMap[key]],
        d = _ref[0],
        e = _ref[1];
      d === null || d === void 0 || (_d$children = d.children) === null || _d$children === void 0 || _d$children.forEach(this.deleteRow);
      if (e) {
        // 删除组件中的节点
        lazyTreeNodeMap[key] = [];
      }

      // 获取根数据
      var rootData = this.table.data.find(function (item) {
        return _this3.getRowKey(item) === key;
      });
      if (!rootData && rootData !== null && rootData !== void 0 && rootData.children) {
        var _this$getTreeProps2 = this.getTreeProps(),
          children = _this$getTreeProps2.children;
        var b = this.table.data;
        this.findRow(key, function () {
          var c = arguments[1].slice(-2, -1)[0];
          if (c) delRow = c[children].splice(arguments[2], 1);else delRow = b.splice(arguments[2], 1);
        });
        return delRow;
      } else {
        return rootData;
      }
    },
    /** 刷新表格
     * @description: 刷新表格
     * @return { void }
     */
    refreshTable: function refreshTable() {
      this.renderData();
      // this.doLayout()
    },
    /** 重载表格
     * @description: 重载表格
     * @return { void }
     */
    doLayout: function doLayout() {
      var _this$$refs$elTable2,
        _this$$refs$elTable3,
        _this4 = this;
      if (typeof ((_this$$refs$elTable2 = this.$refs['el-table']) === null || _this$$refs$elTable2 === void 0 ? void 0 : _this$$refs$elTable2.doLayout) === 'function') (_this$$refs$elTable3 = this.$refs['el-table']) === null || _this$$refs$elTable3 === void 0 || _this$$refs$elTable3.doLayout();else this.$nextTick(function () {
        var _this4$$refs$elTable;
        return (_this4$$refs$elTable = _this4.$refs['el-table']) === null || _this4$$refs$elTable === void 0 ? void 0 : _this4$$refs$elTable.doLayout();
      });
    }
  }
};